export * from './routes';
export * from './generate-path';
import { SafeNavigateProvider } from './safe-navigate';
import { NavigationHistoryProvider } from './navigation-history';

export function RouterProvider({ children }: { children: React.ReactNode }) {
  return (
    <SafeNavigateProvider>
      <NavigationHistoryProvider>{children}</NavigationHistoryProvider>
    </SafeNavigateProvider>
  );
}
